module.exports = __webpack_public_path__ + "templates.member_referral-d5fd46d5.html";